import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import { actorItemSchema, listActorsRequestSchema, listActorsResponseSchema } from "./schema";

export const LIST_ACTORS_PAGE_SIZE = 20;

export const listActorsQuery = createQueryRequestDefinition({
  queryKey: ["mirage", "actors"],
  host: "cap-srv",
  method: "POST",
  path: "mirage/actors/list",
  paramsSchema: listActorsRequestSchema,
  responseSchema: listActorsResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.actors.pageInfo.hasNextPage ? lastPage.actors.pageInfo.endCursor : null;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: LIST_ACTORS_PAGE_SIZE,
    };
  },
});

export const listSavedActorsQuery = createQueryRequestDefinition({
  queryKey: ["mirage", "actors", "saved", "list"],
  host: "cap-srv",
  method: "POST",
  path: "mirage/actors/saved/list",
  responseSchema: z.object({ actors: z.array(actorItemSchema) }),
});

export const getActorQuery = createQueryRequestDefinition({
  queryKey: ["mirage", "actors", "fetch"],
  host: "cap-srv",
  method: "POST",
  path: "mirage/actor/fetch",
  paramsSchema: z.object({ actorId: z.string() }),
  responseSchema: z.object({ actor: actorItemSchema }),
});
